<template>
  <v-btn
      depressed
      :class="className"
      @click="click"
      :to="to"
      :color="color"
      :style="styles"
      :width="width"
      :disabled="disabled || guardDisabled"
      :fab="fab"
      :outlined="outlined"
      :href="href"
  >
    <v-icon class="icon" v-if="showIcon">{{icon}}</v-icon>
    <div><slot/></div>
  </v-btn>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "molecule",
    name: "ActionButton",
    props: {
      "type": String,
      "width": {
        type: String,
        default: "100%"
      },
      "icon": {
        type: String,
        default: "mdi-arrow-right-circle"
      },
      "to": String,
      "small": Boolean,
      "disabled": Boolean,
      "fab": Boolean,
      "href": String
    },
    data () {
      return {
        guardDisabled: false
      }
    },
    computed: {
      color () {
        if (this.type === "banner") {
          return "rgba(10, 27, 53, 0.4)"
        } else if (this.type === "save" || this.type === "search") {
          return "primary"
        } else if (this.type === "delete") {
          return "error"
        } else if (this.type === "cancel") {
          return "accent"
        } else if (this.type === "close") {
          return "info"
        } else if (this.type === "link") {
          if (this.small) {
            return "info"
          }
          return "primary"
        } else if (this.type === "facebook") {
          return "#3071c6"
        } else if (this.type === "twitter") {
          return "#00acf2"
        } else if (this.type === "linkedin") {
          return "#0274b3"
        }
        return "primary"
      },
      borderColor () {
        if (this.type === "banner") {
          return "white"
        }
        return null;
      },
      outlined () {
        if (this.type === "banner") {
          return false
        }
        return true;
      },
      className () {
        let name = "action-btn";
        if (this.small) {
          name += " small"
        }
        if (this.borderColor) {
          name += " border"
        }
        return name;
      },
      styles () {
        if (this.borderColor) {
          return {
            "border-color": this.borderColor
          }
        }
        return {}
      },
      showIcon () {
        return this.icon !== "none"
      }
    },
    methods: {
      click (e) {
        this.$emit("click", e, this.guard)
      },
      guard(process, autoRelease = true) {
        this.guardDisabled = true
        try {
          const release = () => {
            this.guardDisabled = false
          }
          process(release)
        } finally {
          if (autoRelease) {
            this.guardDisabled = false
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">
.v-btn.action-btn
  height: inherit
  color: white
  padding: 16px
  font-weight: bold
  text-transform: none
  &.border
    border-width: 2.11pt
    border-radius: 0
    border-style: solid
  &.small
    padding: 8px 16px
    font-size: 12px
    border-width: 3px
    border-radius: 30px
  .icon
    position: absolute
    left: 0
    font-size: 20px
</style>
